import React from 'react';

export const ClickHereIcon = (props) => (
  <svg {...props} width="611" height="242" viewBox="0 0 611 242" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M596.785 4.00003C603.794 113.681 469.1 211.565 295.938 222.631C171.782 230.565 61.56 191.713 6.53318 128.66" stroke="#CECECE" strokeWidth="2" />
    <path d="M586.394 12.3936L597 1.7868L607.607 12.3936" stroke="#CECECE" strokeWidth="2" />
  </svg>
);
